:host{background-color:#fff}form{display:flex;padding:16px 0 8px;flex-direction:column;align-items:flex-start;gap:16px}.popover-action{display:flex;justify-content:flex-end;width:100%}mat-form-field{width:100%}
/*# sourceMappingURL=upsert-feedback.component.css.map */
